module.exports = __webpack_public_path__ + "static/media/YF_52_11.5ed6d69e.jpg";